import actions from "./actions";

const initState = {
  menuItems: [],
  categories: [],
  reloadCategories: false,
  reloadMenuItems: false,
  syncImageInProgress: false,
  menuItemImage: {},
  itemsTags: [],
  reloadTags: false,
};

export default function reducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_MENU_ITEMS_SUCCESS:
      return {
        ...state,
        menuItems: action.menuItems,
      };

    case actions.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.categories,
      };

    case actions.RELOAD_CATEGORIES_STATE:
      return {
        ...state,
        reloadCategories: !state.reloadCategories,
      };

    case actions.RELOAD_MENU_ITEMS_STATE:
      return {
        ...state,
        reloadMenuItems: !state.reloadMenuItems,
      };

    case actions.RELOAD_ITEMS_TAGS_STATE:
      return {
        ...state,
        reloadTags: !state.reloadTags,
        itemsTags: [],
      };

    case actions.SYNC_MENU_CONFIGURATION_IMAGES_SUCCESS:
      return {
        ...state,
        syncImageInProgress: false,
      };

    case actions.LOADING_SYNC_IMAGES_REQUEST:
      return {
        ...state,
        syncImageInProgress: true,
      };

    case actions.GET_MENU_ITEM_IMAGE_SUCCESS:
      return {
        ...state,
        menuItemImage: action.menuItemImage,
      };

    case actions.GET_ITEMS_TAGS_SUCCESS:
      return {
        ...state,
        itemsTags: action.itemsTags,
      };

    default:
      return state;
  }
}
